import DOMPurify from 'dompurify';

// Central HTML sanitizer for CMS-authored content rendered publicly.
// Allow a moderate set of tags/attributes needed by the TipTap editor.
// Do NOT allow scripts, iframes, on* handlers, style attrs, etc.
const ALLOWED_TAGS = [
  'p', 'br', 'hr',
  'strong', 'em', 'u', 's', 'mark', 'small', 'span',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'ul', 'ol', 'li',
  'blockquote', 'code', 'pre',
  'a',
];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'class', 'data-internal-type', 'data-internal-id'];

export function sanitizeHtml(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(String(dirty), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|\/|#)/i,
    FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed'],
    FORBID_ATTR: ['style'],
  });
}
